import React from 'react'
import { Layout } from 'antd';

export const ContentArea = props => <Layout.Content className={`site-content ${props.transparent ? "transparent" : ""} ${props.className || ""}`} style={props.style} >{props.children}</Layout.Content>
export default ContentArea;